export const STORAGE_KEYS = {
  accessToken: 'accessToken',
  idToken: 'idToken',
  refreshToken: 'refreshToken',
  authorizedToken: 'authorizedToken',
  adminOrSalesFacilityId: 'adminOrSalesFacilityId',
  isSuccess: 'isSuccess',
  userId: 'userId',
  username: 'username',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  phone1: 'phone1',
  country: 'country',
  title: 'title',
  role: 'role',
  roles: 'roles',
  organization: 'organization',
  userInfo: 'userInfo',
  freshChatRestoreId: 'freshChatRestoreId',
  willViewTutorialLater: 'willViewTutorialLater',
  willShowWhatNewPopup: 'willShowWhatNewPopup',
  canUseAiViewer: 'canUseAiViewer',
  isEmailVerified: 'isEmailVerified',
  language: 'language',
  facilityId: 'facilityId',
  groupId: 'groupId',
  isShowLatestVersionModal: 'isShowLatestVersionModal',
  isShowLoginByBanner: 'isShowLoginByBanner',
  isLoginThroughAdmin: 'isLoginThroughAdmin',
  isLoginThroughSales: 'isLoginThroughSales',
  isLoginWithBiocarePortal: 'isLoginWithBiocarePortal',
  isLoginWithMicrosoftAccount: 'isLoginWithMicrosoftAccount',
  loginFrom: 'loginFrom',
  integrationBy: 'integrationBy',
  pathname: 'pathname',
  lastVersionCheckAt: 'lastVersionCheckAt',
  userSupportFacilities: 'userSupportFacilities',
  selectedFacilityLocalStorage: 'selectedFacilityLocalStorage',
  selectedTypeSeePatientsLocalStorage: 'selectedTypeSeePatientsLocalStorage',
  isCheckedViewEcgGuideLineNoti: 'isCheckedViewEcgGuideLineNoti',
  isCheckedNotiCommonQuestions: 'isCheckedNotiCommonQuestions',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
